var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{attrs:{"row":""}},[_c('div',[_c('offer-table',{ref:"violations__violationsTabele",attrs:{"items":_vm.Recommendations,"readOnly":_vm.readOnly,"treeNames":_vm.treeNames,"auditOperationNum":_vm.auditOperationNum,"checkListName":_vm.checkListName,"objectCheck":_vm.objectCheck}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }